/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Chronoctlprereq";
const frontMatter = {};
import {Alert} from '@/components';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <Alert severity="info"><_components.p>{"You need Chronoctl installed and configured. Read the\n"}<_components.a href="/tooling/chronoctl">{"Chronoctl documentation"}</_components.a>{" for more details."}</_components.p></Alert>;
}

export default MDXLayout